<div class="flex-column gap-sm">
  <div class="flex-row align-center mat-h2 gap-sm">
    SMTP-Einstellungen
  </div>

  <mat-divider/>

  <lib-smtp-form-control
    [displayHeaders]="false"
  />
  <div class="button-wrapper">
    <button
      [disabled]="!form()?.instanceId()"
      class="kpi4me-button"
      mat-stroked-button
      color="primary"
      (click)="testSettings()">
      Einstellungen Testen
    </button>
  </div>

</div>
